var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"project_single_page"}},[_c('div',[_vm._v(_vm._s(_vm.$t('required')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }